import logoImg from "@/assets/logo.png";

interface LogoProps {
  variant?: "light" | "dark";
  size?: "sm" | "md" | "lg" | "xl";
  wordmark?: boolean;
  className?: string;
}

export default function Logo({
  size = "md",
  wordmark = true,
  className = "",
}: LogoProps) {
  const sizeClasses = {
    sm: "h-8 max-w-[120px]",
    md: "h-11 max-w-[160px]",
    lg: "h-14 max-w-[200px]",
    xl: "h-20 max-w-[280px]",
  };

  const iconOnlySizes = {
    sm: "h-7 w-7",
    md: "h-9 w-9",
    lg: "h-11 w-11",
    xl: "h-16 w-16",
  };

  if (!wordmark) {
    return (
      <img
        src={logoImg}
        alt="Mandate Pro"
        className={`${iconOnlySizes[size]} object-contain rounded-lg select-none ${className}`}
      />
    );
  }

  return (
    <div className={`inline-flex items-center ${className}`}>
      <img
        src={logoImg}
        alt="Mandate Pro"
        className={`${sizeClasses[size]} w-auto object-contain rounded-xl select-none`}
      />
    </div>
  );
}